module.exports = __webpack_public_path__ + "static/media/image14.fec1cad0.JPG";